import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
// import { updateAALForm } from "../../../redux/fui";
// import { StyledTypographyMessage } from "../FuiStyles";
import { checkWBSECode, checkLicenses } from "./CommonFunctions";
import GeneralForm from "./GeneralForm";
import * as FormField from "./IndividualFormFields";
import * as fuiRedux from "../../../redux/fui/index";

/**
 * Automation Anywhere Licenses Form
 * @author Isabel Sprengers
 * @version 2.0
 * @see Used in component: PlatformLicenseStepper
 */
const AutomationAnywhereLicenses = ({
  history, // get route history
  values, // the value would be changed by user's input
  updateAALForm, //the function to update AALForm values which is from redux
  getNotesValue,
  notesValidations,
  setIsAllValid,
  createdBy,
}) => {
  // check whether WBSECode, ControlRoomLicenses, BotRunnerLicenses, BotCreatorLicenses are valid
  const [isWBSECodeValid, setIsWBSECodeValid] = useState(true);
  const [isControlRoomLicensesValid, setIsControlRoomLicensesValid] = useState(
    true
  );
  const [isBotRunnerLicensesValid, setIsBotRunnerLicensesValid] = useState(
    true
  );
  const [isBotCreatorLicensesValid, setIsBotCreatorLicensesValid] = useState(
    true
  );

  // change validation status
  useEffect(() => {
    setIsAllValid(
      isWBSECodeValid &&
        isControlRoomLicensesValid &&
        isBotCreatorLicensesValid &&
        isBotRunnerLicensesValid
    );
  });

  // get user's input
  const handleChange = (event, fieldName) => {
    const value = event.target.value;
    event.preventDefault();
    updateAALForm(fieldName, value);
    if (fieldName === "WBSEcode") {
      setIsWBSECodeValid(checkWBSECode(value));
    }
    if (fieldName === "NumOfControlRoomlicenses") {
      setIsControlRoomLicensesValid(checkLicenses(value));
    }
    if (fieldName === "NumOfRunnerlicenses") {
      setIsBotRunnerLicensesValid(checkLicenses(value));
    }
    if (fieldName === "NumOfDeveloperlicenses") {
      setIsBotCreatorLicensesValid(checkLicenses(value));
    }
    if (fieldName === "RequestNotes") {
      if (value.length > 0 && value.length < 247) {
        getNotesValue({ emptyString: false, maxLength: false });
      } else if (value.length === 0) {
        getNotesValue({ emptyString: true, maxLength: false });
      } else if (value.length > 246) {
        getNotesValue({ emptyString: false, maxLength: true });
      }
    }
  };

  const isAAAMTermsConditions = values.AAAMTermsConditions === "yes";

  const handleChangeMobileNo = (event, fieldName) => {
    const re = /^[0-9]{0,}$/;
    const value = event.target.value;
    re.test(value) && updateAALForm(fieldName, value);
  };

  return (
    <GeneralForm
      NoConfig={true}
      FormId={5}
      LeftColumnFields={
        <div>
          {FormField.DMSIdField(values, handleChange)}

          {FormField.ClientNameField(handleChange, values)}

          {FormField.SAPContractIDPlatformFieldOthers(values, handleChange)}
        </div>
      }
      RightColumnFields={
        <div>
          {FormField.ProjectNameField(handleChange, values)}
          {FormField.InstanceTypeField(handleChange, values)}

          {values.ChooseNewOrExistingInstance === "Existing" &&
            FormField.ChooseInstanceField(values)}

          {FormField.InstanceNameField(values)}

          {values.ChooseNewOrExistingInstance === "existing" &&
            FormField.InstanceUrlField(values)}
          {createdBy && FormField.CustomerEnterpriseIDField(createdBy, "true")}

          {FormField.DeploymentRegionField(values)}

          {FormField.WBSECodeField(handleChange, values, isWBSECodeValid)}
          {FormField.MobileNumberField(handleChangeMobileNo, values)}

          {FormField.AutomationAnywhereVersionField(handleChange, values)}

          {FormField.LicenseUsageField(handleChange, values)}

          {FormField.ControlRoomLicensesField(
            handleChange,
            values,
            isControlRoomLicensesValid
          )}

          {FormField.BotRunnerLicenseField(
            handleChange,
            values,
            isBotRunnerLicensesValid
          )}
          {FormField.BotCreatorLicenseField(
            handleChange,
            values,
            isBotCreatorLicensesValid
          )}

          {FormField.RequestNotesField(handleChange, values, notesValidations)}

          {FormField.TermsAndConditionsField(
            handleChange,
            values,
            isAAAMTermsConditions
          )}
        </div>
      }
      history={history}
    ></GeneralForm>
  );
};

const MSTP = (state, ownProps) => ({
  email: state.auth.userDetails.email,
  values: state.fui.AALForm,
});

export default connect(MSTP, { updateAALForm: fuiRedux.updateAALForm })(
  withRouter(AutomationAnywhereLicenses)
);
